import React, { useEffect } from 'react';
import { useViewPort } from '../hooks';
import { RootStateType } from '../store/RootState';
import { changeHTMLAttribute } from '../utils/layout';
import { changeSideBarType } from '../store/slices/sideBarlayoutSlice';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import * as layoutConstants from "../constants/layout";


const LayoutConfiguration: React.FC = () => {

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const { width } = useViewPort();

  const {
    layoutDirection,
    layoutWidth,
    topBarTheme,
    sideBarTheme,
    sideBarType,
    layoutPosition,
  } = useSelector((state: RootStateType) => ({
    layoutDirection: state.sideBarlayout.layoutDirection,
    layoutWidth: state.sideBarlayout.layoutWidth,
    topBarTheme: state.sideBarlayout.topBarTheme,
    sideBarTheme: state.sideBarlayout.sideBarTheme,
    sideBarType: state.sideBarlayout.sideBarType,
    layoutPosition: state.sideBarlayout.layoutPosition,
    isOpenRightSideBar: state.sideBarlayout.isOpenRightSideBar,
  }));

  useEffect(() => {
    changeHTMLAttribute('dir', layoutDirection)
  }, [layoutDirection])

  useEffect(() => {
    changeHTMLAttribute('data-layout-width', layoutWidth)
  }, [layoutWidth])

  useEffect(() => {
    changeHTMLAttribute('data-topbar-color', topBarTheme)
  }, [topBarTheme])

  useEffect(() => {
    changeHTMLAttribute('data-menu-color', sideBarTheme)
  }, [sideBarTheme])

  useEffect(() => {
    changeHTMLAttribute('data-sidenav-view', sideBarType)
  }, [sideBarType])

  useEffect(() => {
    changeHTMLAttribute('data-layout-position', layoutPosition)
  }, [layoutPosition])

  useEffect(() => {
    document.getElementsByTagName('html')[0].removeAttribute('data-layout')
  }, [])

  useEffect(() => {
    if (width <= 1140) {
      dispatch(changeSideBarType(layoutConstants.SideBarType.LEFT_SIDEBAR_TYPE_MOBILE));
    } else if (width > 1140) {
      dispatch(changeSideBarType(layoutConstants.SideBarType.LEFT_SIDEBAR_TYPE_DEFAULT));
    }
  }, [width, dispatch])

    return null;
};

export default LayoutConfiguration;